import axios, { AxiosResponse } from "axios";
import { fetchPublicToken } from "./publicTokenService";
import { BASE_URL } from "../helper";
import { getCsrfToken } from "../admin-page/adminHelper";
import Cookies from "js-cookie";


interface User {
    id: number;
    email: string;
}


class AuthService {
    private readonly TOKEN_URL = `${BASE_URL}/auth`

    // store user in memory
    private currentUser: User | null = null;
    private loggedIn: boolean = false;

    async login(email: string , password: string): Promise<boolean>  {
        try{
            
            const response = await axios.post(`${this.TOKEN_URL}/login/`,{email, password}, {
              headers: {
                "X-CSRFToken": getCsrfToken(),
              },
              withCredentials: true});
            if (response.status !== 200) {
                throw new Error("Login failed!")
            }
            this.loggedIn = true
            return true;
        } catch (error :any){
        console.error('Login error: ', error);
        return false;
        }
    }

    async logout(): Promise<void> {
      try {
        await axios.post(`${this.TOKEN_URL}/logout/`,{},
          {
          headers:{
            "X-CSRFToken": getCsrfToken() 
        }, 
        withCredentials: true
      })
      Cookies.remove('refresh_token');
      this.loggedIn = false;
      } catch (error: any) {
        // if 401 err, refresh and try again
        if (error.response?.status === 401){
          const isRefreshed = await this.refreshToken();
          if (!isRefreshed) {
        console.error('Could not refresh token')
          }else{
            await axios.post(`${this.TOKEN_URL}/logout/`,{},
              {
              headers:{
                "X-CSRFToken": getCsrfToken() 
            }, 
            withCredentials: true
          })
      Cookies.remove('refresh_token');
          this.loggedIn = false;
          }
        }
        else{
        console.error('Logout failed:', error);
        } 
      }
    }
    
    async refreshToken(): Promise<boolean> {
        try{
          const refresh_response = await axios.post(`${this.TOKEN_URL}/token/refresh/`,{}, {
            headers: {
              "X-CSRFToken": getCsrfToken()
            },
            withCredentials: true
          })
          if (refresh_response.status !== 200){
            throw new Error("Error occurred while refreshing token");
          }
          return true;
        }catch(err){
          console.error('Token refresh failed:', err);
          return false;
        }
        
    }

 isLoggedIn(): boolean{
  return this.loggedIn;
 }

    async fetchUserData(): Promise<User> {
        try {
            const response = await this.authenticatedRequest<User>(`${this.TOKEN_URL}/me/`, 'get');
            const userData: User = response.data;
            this.currentUser = userData;
            return userData;
          } catch (error) {
            throw error;
          }
    }

    // Get current user data (from memory or fetch if needed)
  async getCurrentUser(): Promise<User | null> {
    if (this.currentUser) {
      return this.currentUser;
    }
      try {
        return await this.fetchUserData();
      } catch (error) {
        console.error('Unable to fetch current user', error);
        return null;
      }
  }


  async authenticatedRequest<T>(url: string, method: string, data: any = null): Promise<AxiosResponse<T>> {
        let publicToken = await fetchPublicToken();
      
        const buildConfig = () => ({
          method: method,
          url: url,
          headers: {
            'X-Public-Token': publicToken,
            ...((method !== 'get') ? { 'X-CSRFToken': getCsrfToken() } : {}),
          },
          withCredentials: true,
          ...((method === 'get' || method === 'delete') && data ? { params: data } : { data: data }),
        });
      
        try {
          let response = await axios(buildConfig());
          return response;
        } catch (err: any) {
          if (err.response?.status === 401) {
            const isRefreshed = await this.refreshToken();
            if (!isRefreshed) {
              throw new Error('Failed to refresh token');
            }
      
            // Retry original request
            return await axios(buildConfig());
          }
      
          // Other errors
          throw err;
        }
      }
      
      
    }

    export const authService = new AuthService();
    export default authService;

